import LegalPageLayout, { type LegalSection } from '../components/layout/LegalPageLayout';
import Seo from '../components/Seo';
import '../styles/legal-pages.css';

const sections: LegalSection[] = [
  { id: 'general', title: '1. Общие положения' },
  { id: 'conditions', title: '2. Условия возврата' },
  { id: 'procedure', title: '3. Порядок возврата' },
  { id: 'denial', title: '4. Случаи отказа' },
  { id: 'contacts', title: '5. Контакты' },
];

export default function RefundPage() {
  return (
    <LegalPageLayout
      title="Политика возврата средств"
      updatedAt="28 января 2026 г."
      version="1.0"
      sections={sections}
    >
      <Seo
        title="Политика возврата средств — Recvisit"
        description="Условия и порядок возврата средств за доступ к SaaS‑сервису Recvisit."
        canonicalPath="/refund"
      />
      <section id="general" className="legal-section">
        <h2>1. Общие положения</h2>
        <p>
          Настоящая Политика определяет порядок и условия возврата денежных средств за доступ к сервису Recvisit (SaaS).
          Политика применяется в части, не противоречащей законодательству Российской Федерации и условиям выбранного
          тарифа.
        </p>
      </section>

      <section id="conditions" className="legal-section">
        <h2>2. Условия возврата</h2>
        <p>
          Возврат может быть рассмотрен в индивидуальном порядке при наличии оснований. По общему правилу возврат
          возможен в течение <strong>7 календарных дней</strong> с момента оплаты при одновременном соблюдении условий:
        </p>
        <ul>
          <li>доступ к сервису не был активирован либо сервис фактически не использовался;</li>
          <li>не производился вход в личный кабинет (или вход был минимальным и не сопровождался использованием);</li>
          <li>не были добавлены сотрудники/объекты (или иные данные, свидетельствующие об использовании сервиса).</li>
        </ul>
        <p>
          Возврат за неиспользованный остаток оплаченного периода, как правило, не производится, если иное прямо не
          предусмотрено условиями тарифа или законом.
        </p>
      </section>

      <section id="procedure" className="legal-section">
        <h2>3. Порядок возврата</h2>
        <p>
          Для рассмотрения возврата необходимо направить запрос на email{' '}
          <a href="mailto:info@recvi.ru">info@recvi.ru</a> с указанием:
        </p>
        <ul>
          <li>ФИО/наименование Заказчика;</li>
          <li>даты и суммы оплаты;</li>
          <li>идентификатора платежа (если есть);</li>
          <li>причины возврата;</li>
          <li>контактных данных для обратной связи.</li>
        </ul>
        <p>
          Срок рассмотрения запроса — до <strong>10 рабочих дней</strong>. Возврат осуществляется тем же способом, которым
          была произведена оплата, если иное невозможно по техническим причинам.
        </p>
        <p>
          Комиссии платежных систем/банков (если применимо) не подлежат возврату.
        </p>
      </section>

      <section id="denial" className="legal-section">
        <h2>4. Случаи отказа</h2>
        <p>Возврат может быть отклонен, в том числе, если:</p>
        <ul>
          <li>истек срок 7 календарных дней с момента оплаты;</li>
          <li>сервис был активирован и/или использовался;</li>
          <li>добавлялись сотрудники/объекты или формировались отчеты;</li>
          <li>имеются признаки злоупотребления правом или недобросовестного поведения.</li>
        </ul>
      </section>

      <section id="contacts" className="legal-section">
        <h2>5. Контакты</h2>
        <p>
          По вопросам возврата: <a href="mailto:info@recvi.ru">info@recvi.ru</a>.
        </p>
      </section>
    </LegalPageLayout>
  );
}

